/// <reference path="./core/wpt.ts" />
// @ts-check

/*
 * gateway.js - used/called by gateway.html
 * 
 * Resets the URL in the browser bar to index.html and removes the version
 * in the query parameters.
 * Starts the initialisation of the WPT core functionalities.
 */


let newUrl = 'index.html';
if (window.location.search.length > 1) {
    let newSearch = '?';
    let firstSet = false;
    let queryParts = window.location.search.substring(1).split('&');
    for (let i = 0; i < queryParts.length; i++) {
        if (!queryParts[i].startsWith('ver=')) {
            if (firstSet) {
                newSearch += '&';
            } else {
                firstSet = true;
            }
            newSearch += queryParts[i];
        }
    }
    if (newSearch.length > 1) {
        newUrl += newSearch;
    }
}
newUrl += window.location.hash;

window.history.replaceState('Web Portal Toolkit', 'Web Portal Toolkit - Gateway', newUrl);


let WPT = new WPTNamespace.WPTCore();
